import axios from 'axios';

export default {
  all(params = {}) {
    return axios.get('/users/admin', {params});
  },
  getUnregistered(params = {}) {
    return axios.get('/users/admin/unregistered', {params});
  },
  getChemists(params = {}) {
    return axios.get('/users/chemist', {params});
  },
  getUserFile(params = {}) {
    return axios.get('/user/file', {params});
  },
  getDetailUser(params = {}) {
    return axios.get('/user/detail', {params});
  },
  getDoctors(params = {}) {
    return axios.get('/users/doctor', {params});
  },
  getCustomers(params = {}) {
    return axios.get('/users/customers', {params});
  },
  detail(id: string | number, params = {}) {
    return axios.get(`/master/admin/${id}`, {params});
  },
  assignUser(payload = {}) {
    return axios.post(`/users/admin/register`, payload);
  },
  saveCertificate(payload = {}) {
    return axios.post(`/user/certificate`, payload);
  },
  getCertificate(params = {}) {
    return axios.get('/user/certificate', {params});
  },
  deleteCertificate(id: string | number) {
    return axios.delete(`/user/certificate/${id}`);
  },
  deleteFile(payload = {}) {
    return axios.delete(`/asset/delete`, {data: payload});
  },
  uploadUrlFile(payload = null) {
    return axios.post(`/user/file`, payload);
  },
  Selfie(payload = null) {
    return axios.put(`/user/selfie`, payload);
  },
  upload(payload = null) {
    return axios.post(`/asset/upload`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
